module.exports = __webpack_public_path__ + "assets/b58f6b15597515fbdc68fe138ffe53f0.png";